export const SET_FILTER = 'SET_FILTER';

export default function filters(state = {}, action) {
  switch (action.type) {
    case SET_FILTER:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}

export function setFilters(filters) {
  return dispatch => {
    dispatch({
      type: SET_FILTER,
      payload: filters
    });
  };
}
